// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3511":"css/app.6711","6930":"css/admin-app.6711"}[chunkId] + ".css";
};